import { render, staticRenderFns } from "./CurrentNegotiationUserColumnTemplate.vue?vue&type=template&id=0ec895bb"
import script from "./CurrentNegotiationUserColumnTemplate.vue?vue&type=script&lang=js"
export * from "./CurrentNegotiationUserColumnTemplate.vue?vue&type=script&lang=js"
import style0 from "./CurrentNegotiationUserColumnTemplate.vue?vue&type=style&index=0&id=0ec895bb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports